import {
  getReq,
  postReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'

const state = {
  projUserSearchInfo: {
    legalName: '',
    mobile: '',
    compId: ''
  },
  projUserListObject: {
    projUserList: [],
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPage: 0
  },
  projUserInfo: {
    compId: '',
    userId: '',
    familyName: '',
    firstName: '',
    mobile: '',
    status: '',
    projectPositionList: []
  },
  projectPositionInfo: {
    projId: '',
    projPositionKeyList: []
  },
  END_STATE: null
}
const getters = {}
const actions = {
  async findProjectUserCondition({
    commit,
    state,
    rootState
  }, { currentPage, pageSize, codeParam }) {
    let stateCurrentPage = currentPage
    if (pageSize) {
      state.projUserListObject.pageSize = pageSize
      stateCurrentPage = 1
    }
    const projUserListObject = await postReq(END_POINTS.FIND_PROJECT_USER_CONDITION, {
      data: {
        currentPage: stateCurrentPage,
        orderBy: '',
        pageSize: state.projUserListObject.pageSize,
        queryVO: {
          legalName: state.projUserSearchInfo.legalName,
          compId: state.projUserSearchInfo.compId,
          mobile: state.projUserSearchInfo.mobile
        },
        refreshTotalRecord: true
      },
      headerMap: await getCPHeaderMap(state.projUserSearchInfo.compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjUserListObject', projUserListObject)
  },
  async findProjectUser({
    commit
  }, {userId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_PROJECT_USER + `?userId=${userId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateProjUserInfo', responseData.data)
    } else {
      commit('updateProjUserInfo', {})
    }
  },
  async assignProjectUser({
    dispatch,
    commit,
    state
  }, {userId, compId, projList, codeParam}) {
    const projUserInfo = {
      familyName: state.projUserInfo.familyName,
      firstName: state.projUserInfo.firstName,
      mobile: state.projUserInfo.mobile,
      projectPositionList: projList,
      userId: userId,
      compId: compId
    }
    const updateObject = await postReq(END_POINTS.ASSIGN_PROJECT_USER, {
      data: projUserInfo,
      headerMap: await getCPHeaderMap(compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  }
}

const mutations = {
  updateSearchCompId(state, value) {
    state.projUserSearchInfo.compId = value
  },
  updateSearchLegalName(state, value) {
    state.projUserSearchInfo.legalName = value
  },
  updateSearchMobile(state, value) {
    state.projUserSearchInfo.mobile = value
  },
  updateProjUserListObject(state, projUserListObject) {
    if (projUserListObject.code === 2001) {
      state.projUserListObject.projUserList = projUserListObject.data.map(value => {
        return {
          userId: value.userId,
          familyName: value.familyName,
          firstName: value.firstName,
          mobile: value.mobile,
          compId: value.compId,
          status: value.status,
          projectPositionList: value.projectPositionList
        }
      })
      state.projUserListObject.currentPage = projUserListObject.currentPage
      state.projUserListObject.pageSize = projUserListObject.pageSize
      state.projUserListObject.total = projUserListObject.total
      state.projUserListObject.totalPage = projUserListObject.totalPage
    } else {
      state.projUserListObject.projUserList = []
      state.projUserListObject.total = 0
    }
  },
  updateProjUserInfo(state, projUserInfo) {
    // debugger
    state.projUserInfo.userId = projUserInfo.userId
    state.projUserInfo.familyName = projUserInfo.familyName
    state.projUserInfo.firstName = projUserInfo.firstName
    state.projUserInfo.mobile = projUserInfo.mobile
    state.projUserInfo.compId = projUserInfo.compId
    state.projUserInfo.status = projUserInfo.status
    state.projUserInfo.projectPositionList = projUserInfo.projectPositionList
  },
  // updateProjUserSearchInfo(state, projUserSearchInfo) {
  //   state.projUserSearchInfo.compId = projUserSearchInfo.compId
  //   state.projUserSearchInfo.legalName = projUserSearchInfo.legalName
  //   state.projUserSearchInfo.mobile = projUserSearchInfo.mobile
  // },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/projuser/rspProjUserManage.js